import { SI_ROOT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

// UI-Router reads the `states` export from the lazy-loaded module and registers each state.
// The AA states-config module also registers Display/Search/Social/LLMs SI states,
// so all the globs below resolve to the same lazy module.
const advertiserActivityLazyLoad = () =>
    import("app/pages/sales-intelligence/pages/ad-intelligence/advertiser-activity/routing/states-config");

export const salesAdvertiserActivityFutureConfig: RouterStateConfig = {
    "salesIntelligence-advertiseractivity.**": {
        parent: SI_ROOT_ROUTE,
        url: "/advertiseractivity",
        lazyLoad: advertiserActivityLazyLoad,
    },
    "salesIntelligence-adintelligence-displayadvertising.**": {
        parent: SI_ROOT_ROUTE,
        url: "/displayadvertising",
        lazyLoad: advertiserActivityLazyLoad,
    },
    "salesIntelligence-adintelligence-searchadvertising.**": {
        parent: SI_ROOT_ROUTE,
        url: "/searchadvertising",
        lazyLoad: advertiserActivityLazyLoad,
    },
    "salesIntelligence-social-channels.**": {
        parent: SI_ROOT_ROUTE,
        url: "/social-channels",
        lazyLoad: advertiserActivityLazyLoad,
    },
    "salesIntelligence-llms-channels.**": {
        parent: SI_ROOT_ROUTE,
        url: "/llms-channels",
        lazyLoad: advertiserActivityLazyLoad,
    },
};

export const salesPublisherAnalysisFutureConfig: RouterStateConfig = {
    "salesIntelligence-publisheranalysis.**": {
        parent: SI_ROOT_ROUTE,
        url: "/publisheranalysis",
        lazyLoad: () =>
            import("app/pages/sales-intelligence/pages/ad-intelligence/publisher-analysis/routing/states-config"),
    },
};

const monitorAndProtectLazyLoad = () =>
    import("app/pages/sales-intelligence/pages/ad-intelligence/monitor-and-protect/routing/states-config");

export const salesMonitorAndProtectFutureConfig: RouterStateConfig = {
    "salesIntelligence-monitorandprotect.**": {
        parent: SI_ROOT_ROUTE,
        url: "/monitorandprotect",
        lazyLoad: monitorAndProtectLazyLoad,
    },
    // Trademark states are separate top-level name tokens (hyphen, not dot), so the glob
    // above does not cover them. Without their own future-states a deep-link / refresh to a
    // trademark URL has nothing to trigger the lazy chunk. Both point at the same chunk.
    "salesIntelligence-monitorandprotect-trademark-abstract.**": {
        parent: SI_ROOT_ROUTE,
        url: "/monitorandprotect/trademark",
        lazyLoad: monitorAndProtectLazyLoad,
    },
    "salesIntelligence-monitorandprotect-trademark-root-violations.**": {
        parent: SI_ROOT_ROUTE,
        url: "/monitorandprotect/trademark/violations",
        lazyLoad: monitorAndProtectLazyLoad,
    },
};
